<template>
    <div>
        <div v-bind:id="setId" v-bind:style="{width: chartWidth,height: chartHeight}"></div>
    </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      charts: "",
      opinionData: []
    };
  },
  props: ["getData", "chartWidth", "chartHeight", "setId"],
  methods: {
    dealSeries: function() {
      let data = [];
      console.log(this.getData);
      let avgSort = this.getData.list.avg.sort();
      let avgData = [];
      for(var i = 0; i < avgSort.length; i++){
        if(i < avgSort.length/2){
          avgData.push({
            value:avgSort[i],
            symbol:"image://./static/img/chart_icon.png",
          });
        }else{
          avgData.push({
            value:avgSort[i],
            symbol:"image://./static/img/chart2_icon.png",
          });
        }
      }
      if(this.getData.list.avg.length > 0){
        data.push({
          name: "ISR",
          type: "scatter",
          label:{
              show:true,
              position:'top',
              distance:5,
              color:'#333'
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#858484" },
                { offset: 1, color: "#272626" }
              ])
            }
          },
          yAxisIndex: 1,
          data:avgData
        });
      }
      
      if(this.getData.list.income.length > 0){
        let income = this.getData.list.income;
        let incomeData = [];
        for(var j = 0; j < income.length; j++){
          if(income[j] > 0){
            incomeData.push({
              value:income[j],
              label:{
                show:true,
                position:'top',
                distance:5,
                color:'#333'
              },
            });
          }else{
            incomeData.push({
              value:income[j],
              label:{
                show:true,
                position:'insideBottom',
                distance:5,
                color:'#333'
              },
            });
          }
        }

        let profit = this.getData.list.profit;
        let profitData = [];
        for(var m = 0; m < profit.length; m++){
          if(profit[m] > 0){
            profitData.push({
              value:profit[m],
              label:{
                show:true,
                position:'top',
                distance:20,
                color:'#333',
                fontSize:10
              },
            });
          }else{
            profitData.push({
              value:profit[m],
              label:{
                show:true,
                position:'insideBottom',
                distance:5,
                color:'#333'
              },
            });
          }
        }

        data.push({
          name: "收益",
          type: "bar",
          itemStyle: {
            normal: {
              color: '#f28e2b'
            }
          },
          label:{
              formatter:function(data){
                console.log(data);
                return data.value/1000 + 'k';
              },
              fontSize:10
          },
          barWidth: "30%",
          data:profitData
        });

        data.push({
          name: "预估利润",
          type: "bar",
          itemStyle: {
            normal: {
              color: '#4e79a7'
            }
          },
          label:{
              formatter:function(data){
                console.log(data);
                return data.value/1000 + 'k';
              },
              fontSize:10
          },
          barWidth: "20%",
          barGap : '-85%',
          data:incomeData
        });
      }
      
      return data;
    },
    drawPie: function(id) {
      let that = this;
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "item",
          formatter:function(parames){
            return '目标天数 : '+ parames.name + '<br />'+ parames.seriesName + ' : ' + parames.value;
          }
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          bottom: -5,
          data: ["ISR", "收益", "预估利润"]
        },
        grid: {
          top: 30,
          left: 70,
          right: 60,
          bottom: 30
        },
        color: ["#858484", "#27B9FA", "#FA9B18"],
        xAxis: [
          {
            name: "目标天数",
            nameTextStyle: {
              fontSize: 10,
              padding: [0, 0, -5, 0]
            },
            offset: 10,
            type: "category",
            boundaryGap: true,
            axisTick: {
              show: false
            },
            axisLabel: {
              padding: [-15, 0, 0, 0]
            },
            data: this.getData.days
          }
        ],
        dataZoom: [
          {
          show: false,
          realtime: true,
          start: 0,
          end: 240
          },
          {
          type: 'inside',
          realtime: true,
          start: 0,
          end: 240
          }
        ],
        yAxis: [
          {
            name: "",
            nameTextStyle: {
              fontSize: 10,
              padding: [0, 0, -5, 0]
            },
            type: "value",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
             axisLabel:{
              show: false
            },
            splitLine: {
              show: false
            },
            min:function(value){
              if(value.max < 0){
                  return value.min;
              }else if(value.min > 0){
                  return 1/2*value.min;
              }else{
                return value.min;
              }
            },
            max: function(value) {
              if(value.max < 0){
                return 0;
              }else if(value.min > 0){
                  return 2*value.max;
              }else{
                return value.max;
              }
            }
          },
          {
            name: "",
            nameTextStyle: {
              fontSize: 10,
              padding: [0, 0, -5, 0]
            },
            type: "value",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel:{
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: this.dealSeries()
      });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      //this.dealSeries();
      this.drawPie(this.setId);
    });
  },
  watch:{
        getData(val){    
          this.drawPie(this.setId);
        }
      }
};
</script>




// WEBPACK FOOTER //
// src/components/common/chart2.vue